// extracted by mini-css-extract-plugin
module.exports = {"SectionA2":"SectionA2U_SectionA2__5mYII"};